import { Component, EventEmitter, Output, OnInit } from '@angular/core';
import { SortDirection, SortType } from '../../constants-types';
import { IconSize, IconType, SearchState, User } from '../../core-data-model';
import { SearchStateFactory, UserApi } from '../../core-services';
import { TranslationService } from '../../translations';
import { MyProfileTooltipService } from '../profile-tooltip/my-profile-tooltip.service';

@Component({
    selector: `users-and-ba-reports`,
    templateUrl: 'users-and-ba-reports.component.html',
    styleUrls: ['./users-and-ba-reports.less'],
    standalone: false
})
export class UsersAndBaReportsComponent implements OnInit {
    searchState: SearchState;
    usersCollection: User[];
    maxResult = 50;
    isDownloading: boolean;
    isLoadingUsers: boolean;

    IconSize = IconSize;
    IconType = IconType;

    @Output()
    reportDownloading: EventEmitter<boolean> = new EventEmitter();

    constructor(
        public TR: TranslationService,
        private searchFactory: SearchStateFactory,
        private userApi: UserApi,
        private tooltipService: MyProfileTooltipService
    ) {}

    async ngOnInit() {
        this.isLoadingUsers = true;
        this.searchState = this.searchFactory
            .newSearchState()
            .setPageSize(this.maxResult)
            .addSort(SortType.Name, SortDirection.Ascending);
        this.usersCollection = await this.userApi.searchUsers(
            this.searchState,
            'users'
        );
        this.isLoadingUsers = false;
    }

    async downloadReport(user: User) {
        this.reportDownloading.emit(true);
        if (!this.isDownloading) {
            this.isDownloading = true;
            await this.tooltipService.downloadReport(user);
            this.isDownloading = false;
        }
    }
}
